// extracted by mini-css-extract-plugin
export default {"wrapper":"AssistantsTab_wrapper__WkI6f","headerSectionWrapper":"AssistantsTab_headerSectionWrapper__2HDP3","title":"AssistantsTab_title__BLte4","ell":"AssistantsTab_ell__0seh4"};